/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_DescriptionInputs */

const en_diff_description = /** @type {(inputs: Diff_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two JSON documents and find differences. Highlight added, removed, and changed values.`)
};

const ko_diff_description = /** @type {(inputs: Diff_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 JSON 문서를 비교하고 차이점을 찾으세요. 추가, 삭제, 변경된 값을 하이라이트합니다.`)
};

const ja_diff_description = /** @type {(inputs: Diff_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つのJSONドキュメントを比較して差分を検出。追加、削除、変更された値をハイライトします。`)
};

/**
* | output |
* | --- |
* | "Compare two JSON documents and find differences. Highlight added, removed, and changed values." |
*
* @param {Diff_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_description = /** @type {((inputs?: Diff_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_description(inputs)
	if (locale === "ko") return ko_diff_description(inputs)
	return ja_diff_description(inputs)
});